import { APP_INITIALIZER, enableProdMode, ErrorHandler, importProvidersFrom } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular';
import { register as registerSwiperElements } from 'swiper/element/bundle';


import { AppModule, getLang, HttpLoaderFactory } from './app/app.module';
import { environment } from './environments/environment';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { environment as environment_1 } from '@cx-env/environment';
import { provideAuth, getAuth } from '@angular/fire/auth';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { SharedModule } from '@cx-shared/shared.module';
import { BlockUIModule } from 'ng-block-ui';
import { SpinnerComponent } from '@cx-shared/components/spinner/spinner.component';
import { AppRoutingModule } from './app/app-routing.module';
import { provideAnimations } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ToastrModule } from 'ngx-toastr';
import { AppComponent } from './app/app.component';

const firebaseConfig = environment.firebase;
const storageLang = localStorage.getItem('cx-lang');
let defaultLang = 'en'
const browserLang =
        navigator.language.split('-')[0] ||
        'en';



registerSwiperElements();

Sentry.init({
  dsn: environment.sentry.dsn,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  environment: environment.production ? 'production':'development',
  // Performance Monitoring
  tracesSampleRate: 0.4, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['localhost', environment.apiBaseUrl],
  // Session Replay
  // tslint:disable-next-line:max-line-length
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  // tslint:disable-next-line:max-line-length
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(BrowserModule, SharedModule, BlockUIModule.forRoot({
            template: SpinnerComponent,
        }), AppRoutingModule, NgbModule, TranslateModule.forRoot({
            defaultLanguage: getLang(),
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient],
            },
        }), ToastrModule.forRoot()),
        {
            provide: ErrorHandler,
            useValue: Sentry.createErrorHandler(),
        },
        {
            provide: Sentry.TraceService,
            deps: [Router],
        },
        {
            provide: APP_INITIALIZER,
            useFactory: () => () => {},
            deps: [Sentry.TraceService],
            multi: true,
        },
        CookieService,
        provideFirebaseApp(() => initializeApp(firebaseConfig)),
        provideAuth(() => getAuth()),
        provideAnimations()
    ]
})
  .catch(err => console.error(err));
